<template>
  <div v-if="isVisible" class="popup">
    <div class="popup-content">
      <div class="close-btn" @click="closePopup">&times;</div>
      <!-- <div class="image"> -->
      <img class="img img-fluid" src="images/promocja/pop-up.webp" alt="POPUP konfigurator">
      <!-- </div> -->
      <a target="_blank" href="https://wiked.pl/promo-1-pln/" class="btn btn-success more">Dowiedz
        się więcej</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    // Otwieraj popup po 2 sekundach od załadowania komponentu
    setTimeout(() => {
      // this.isVisible = true;
    }, 500);
  },
  methods: {
    closePopup() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  /* Przezroczyste tło */
  z-index: 9;
  /* Z-index dla popupu */
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  position: relative;
  background-color: white;
  /* padding: 20px; */
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  max-width: 90%;
  /* Maksymalna szerokość kontenera */
  max-height: 90%;
  /* Maksymalna wysokość kontenera */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  /* Ukrywa wszystko poza kontenerem */
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  /* background: none; */
  /* border: none; */
  font-size: 40px;
  cursor: pointer;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
}

.close-btn:hover {
  color: red;
}

.img {
  width: auto;
  /* Dostosowuje szerokość do proporcji */
  height: 100%;
  /* Wysokość obrazu jest ograniczona do kontenera */
  max-height: 90svh;
  /* Ustawienie maksymalnej wysokości obrazu na 90% okna */
  object-fit: contain;
  /* Zapewnia dopasowanie obrazu przy zachowaniu proporcji */
}

.btn-success {
  background-color: #8FCC25 !important;
  border-color: #8FCC25 !important;
}

.btn-success:hover,
.btn-success:focus {
  background-color: #7EB822 !important;
  border-color: #7EB822 !important;
}

.more {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
</style>